import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Breadcrumb from '../components/Breadcrumb';

const BlogDetail = () => {
  const breadcrumbItems = [
    { label: "Trang chủ", href: "/" },
    { label: "Tin tức", href: "/blogs" },
    { label: "The Ultimate Guide to Marketing Strategies to Improve Sales" },
  ];
  return (
    <>
      <Breadcrumb items={breadcrumbItems} />
      <div className="w-full  flex justify-center items-center mt-8 p-4 xl:p-0">
        <div className="w-[--page-width] ">


          {/* Hình ảnh */}
          <div className="mb-6">
            <img
              src="https://images.pexels.com/photos/4004122/pexels-photo-4004122.jpeg"
              alt="Blog banner"
              className="w-full rounded-lg"
            />
          </div>

          {/* Tiêu đề + meta info */}
          <h1 className="text-2xl md:text-3xl font-bold mb-3">
            The Ultimate Guide to Marketing Strategies to Improve Sales
          </h1>
          <div className="text-sm text-gray-600 mb-6">
            <span>July 5, 2024</span> • <span>Seenu Rawat</span>
          </div>

          {/* Nội dung bài viết */}
          <div className="prose max-w-none">
            <p>
              Many things about electronic devices your kids don’t want you to know.
            </p>
            <p>
              How storage devices can help you predict the future. Why mom was right
              about wholesale accessories. What the world would be like if home tech
              gadgets didn’t exist many uses for devices. How devices can help you
              predict the future. Ways landscape architectures are completely
              overrated.
            </p>

            <h3>Maiores Illum</h3>
            <ul>
              <li>Nobis ut qui a quis</li>
              <li>Ut ullam hic aut</li>
              <li>Ratione sit itaque fugiat itaque dolor</li>
            </ul>

            <p>
              Ut enim nihil quibusdam eius. Ut nam atque nesciunt tempora. Nihil qua
              corrupti sed fugiat accusamus fugit. Animi accusantium atque culpa
              rerum aut. Qui sit illum laudantium veniam voluptatibus.
            </p>

            <blockquote>
              "Tempore hic rerum rerum iusto magni maxime et."
            </blockquote>

            <p>
              Magnam ipsum hic aut. Amet quas voluptates hic aperiam eaque.
              Explicabo sunt optio odio sint tempore sunt.
            </p>

            <h3>Voluptatem ab</h3>
            <p>
              Sit ex numquam odio sed molestias illo ducimus et voluptatum sed
              voluptatibus ipsum aut explicabo.
            </p>
          </div>

          <div className='w-full flex underline justify-center items-center my-4'> <Link to={"/blogs"}>Quay lại trang tin tức</Link></div>
        </div>
      </div>
    </>
  )
}
export default BlogDetail
